import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  list: [],
};

const assetSlice = createSlice({
  name: "assetSlice",
  initialState,
  reducers: {
    saveAssetList: (state, action) => {
      state.list = action.payload.list;
    },
    removeAssetList: (state) => {
      state.list = [];
    },
  },
});

export const { saveAssetList, removeAssetList } = assetSlice.actions;
export default assetSlice.reducer;
